enum Sizes {
  EXTRA_SMALL,
  SMALL,
  MEDIUM,
  LARGE,
}

export default Sizes;
